import { render, staticRenderFns } from "./DestinationListComponent.vue?vue&type=template&id=25fef8d5&scoped=true&"
import script from "./DestinationListComponent.vue?vue&type=script&lang=js&"
export * from "./DestinationListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fef8d5",
  null
  
)

export default component.exports